import { makeStyles } from "@material-ui/core/styles";

const theme = (props) => {
  const styles = makeStyles(theme => ({
    container: {
      padding: 20,
      '& .title': {
        color: '#374151',
        fontWeight: 500,
        fontSize: 20,
        marginBottom: 20,
      },
      '& .label': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 14,
        marginBottom: 20,
      },
    },
    agreementsContainer: {
      padding: 20,
      marginTop: 15,
      '& .title': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 20,
        marginBottom: 20,
      },
      '& .label': {
        color: '#989898',
        fontWeight: 500,
        fontSize: 14,
        marginBottom: 20,
      },
      '& li': {
        listStyleType: "square",
        textDecoration: "underline",
        color: "#292991",
        cursor: "pointer",
        marginBottom: 5,

        '&::marker': {
          fontSize: 20,
          color: "#989898"
        },
      },
    },
    filenameText: {
      textDecoration: "underline",
      cursor: "pointer"
    },

    warningContainer: {
      marginTop: 14,
      padding: 0,
      borderRadius: 12,
      border: '1px solid rgba(12,27,77,0.15)',
      background: 'linear-gradient(180deg, #F8FAFF 0%, #F2F6FF 100%)',
      boxShadow: '0 4px 14px rgba(17,24,39,0.06)',
      overflow: 'hidden',
      display: 'none',
    },

    warningInner: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 10,
      padding: '12px 14px',
      //borderLeft: `4px solid ${props.color2 || '#0C1B4D'}`,
    },

    warningInnerButton: {
      display: 'block',
      width: '100%',
      textAlign: 'left',
    },

    warningText: {
      color: '#1F2937',
      fontSize: 14,
      fontWeight: 500,
      lineHeight: 1.4,
      margin: 0,
    },

    warningIcon: {
      color: props.color2 || '#0C1B4D',
      fontSize: 20,
      flexShrink: 0,
    },

    infoContainer: {
      marginTop: 12,
    },


    '@media (max-width: 600px)': {
      container: {
        padding: 14,
        '& .title': {
          fontSize: 'var(--mobile-title-size)',
          lineHeight: 'var(--lh-title)',
          marginBottom: 12,
          color: 'var(--text-strong)!important',
        },
        '& .label': {
          marginBottom: 4,
          fontSize: 'var(--mobile-label-size)',
          letterSpacing: 0.25,
          color: 'var(--text-muted)',
        },
        '& .text': {
          fontWeight: 400,
          marginBottom: 6,
          color: 'var(--text-body)',
          fontSize: 'var(--mobile-body-size)',
          lineHeight: 'var(--lh-body)',
          '& p': {
            margin: '0 0 4px 0',
            '&:last-child': {
              marginBottom: 0,
            },  
          },
          
        },
        '& li': {
          color: 'var(--text-link)',
        }
      },
      agreementsContainer: {
        padding: 14,
        marginTop: 12,
        '& .title': {
          fontSize: 18,
          marginBottom: 12,
        },
        '& .label': {
          fontSize: 14,
          marginBottom: 12,
        },
      },

      infoContainer: {
        display: 'none',
      },
      warningContainer: {
        display: 'block',
      },

    }
  }));
  return styles();
}
export default theme;

